<template>
    <div class="home-page">
		<Header></Header>
		<div class="nav flex">
			<div class="back" @click="back">
				<img src="static/images/return.png" />
			</div>
			<span class="">{{$t('settings')}}</span>
		</div>
		<div class="content mt50 por">
			<div class="home1 flex-center disflex">
				<div class="info ac" style="width:360px">
					<router-link :to="{path:'/myAccount'}">
						<img class="" src="static/images/accout-img2.png" />
						<div class="name mt10 fs40">{{$t('myAccount')}}</div>
					</router-link>
					<div class="phone fs33 ovhidden crfff mt30">{{info.mobile}}</div>
					<div class="jifen fs33 mt30 crfff">
						{{$t('Member_since')}} <div>{{time}}</div>
					</div>
				</div>
				<div class="w251 ac ml50" style="width:210px;">
					<router-link :to="{path:'/faq'}">
						<div class="settings">
							<i class="icons i-faqs"></i>
							<span class="fs33 mt10" style="line-height: 22px;">{{$t('FAQs')}} </span>
						</div>
					</router-link>
					<router-link :to="{path:'/termsAndCondition'}">
						<div class="ranking" style="margin:40px 0px 20px;display: block;">
							<i class="icons i-tc"></i>
							<span class="fs33 mt10">{{$t('T_C')}}</span>
						</div>
					</router-link>
					<!-- <router-link :to="{path:'/privicyPolicy'}">
						<div class="policy">
							<i class="icons i-policy"></i>
							<span class="fs33 policy-text mt10" style="font-size:28px;">{{$t('Privacy_Policy')}}</span>
						</div>
					</router-link> -->
				</div>
			</div>
			<div class="unsubscribe" @click="unSubscribe">
				<button class="button active mt100 fs40">{{$t('UNSUBSCRIBE')}}</button>
			</div>
		</div>
		<div class="ac mt100">
			<img src="static/images/bg4.png" />
		</div>
		<Dialog ref="saveDialog" :callback="saveModal" title="" :btnText="$t('Confirm')" :cancelText="$t('cancel')">
            <div slot="mdBox" >
                <div class="ac fs40">{{$t('des')}}</div>
            </div>
        </Dialog>
	</div>
</template>
<script>
import Header from '../components/header'
import Dialog from '../components/dialog'
export default {
    components:{
		Header,
		Dialog
    },
    data() {

        return {
			info:'',
			time:'',

		}
    },
	watch: {

	},
	computed:{
	},
    mounted() {
		let that = this;
    },
	created(){
		this.getHome();
	},
    methods: {
		back(){
			this.$router.go(-1);
		},
		unSubscribe(){
			this.isShow = false;
			this.$refs.saveDialog.showMaskFun();
		},
		// 弹框保存
		saveModal (){
			let that =this;
			that.$refs.saveDialog.closeMask();
			let data = {
				'token':localStorage.getItem('token'),
				uuid:localStorage.getItem('uuid')
			}
			that.$api.post('/user/unreg',data,r =>{
				that.$parent.returnCode(r,function(){
					that.$router.push('/login');
					localStorage.removeItem('token')
					localStorage.removeItem('uuid')
					localStorage.removeItem('mobile')
                });

			})
		},
		getHome(){
			let that =this;
			//that.$parent.loadModal(true);
			let data = {'token':localStorage.getItem('token'),uuid:localStorage.getItem('uuid')}
			that.$api.post('/user/info',data,r =>{
				that.$parent.returnCode(r,function(){
					that.info = r.data
					that.time = that.info.created_at.trim().split(" ")[0].replace(/-/g,'/')
					that.$parent.loadModal(false);
                });

			})
		}
	}
}
</script>
<style>
</style>



// WEBPACK FOOTER //
// src/page/setting.vue